<div class="card" id="recent-receipts">
    <div class="card-body">
        <h2 class="card-title">Paid</h2>
        <form [formGroup]="form">
            <div class="form-group">
                <input type="search" id="find-receipt" class="form-control form-control-sm" formControlName="number" autocomplete="off" placeholder="Find receipt by #" />
            </div>
        </form>
    </div>
    <ul class="list-group list-group-flush receipt-list">
        @if ((!receipts || (receipts.length <= 0))) { 
            <li class="list-group-item empty">No recent receipts at this time.</li>
        }
        @for (receipt of receipts; track receipt.id) {
            <li class="list-group-item" (click)="selected($event, receipt)">
                <span class="material-icons">{{icon(receipt.category)}}</span>
                <div class="due">
                    <p class="title">{{receipt.paid | date:'MMM d, yy'}}</p>
                    @if (receipt.status.toLocaleLowerCase() !== 'ready') {
                        <p class="text-truncate subtitle text-danger">{{receipt.status.toLocaleLowerCase()}}</p>
                    }
                </div>
                @if (!contactId || (contactId <= 0)) { 
                    <div class="text-truncate">
                        <p class="title">{{receipt.payer}}</p>
                        <p class="subtitle">{{receipt.stock}} {{receipt.vehicle}}</p>
                    </div>
                }
                @if (contactId && (contactId > 0)) {
                    <div class="text-truncate">
                        <p class="title">{{receipt.stock}} {{receipt.vehicle}}</p>
                        @if ((receipt.status.toLocaleLowerCase() === 'failed') && receipt.reason && (receipt.reason.length > 0)) {
                            <p class="text-danger subtitle" title="{{receipt.reason | lowercase}}">{{receipt.reason | lowercase}}</p>
                        }
                        @else {
                            <p class="subtitle">{{receipt.source | lowercase}} with {{receipt.method | lowercase}}</p>
                        }
                    </div>
                }
                <p class="text-center">{{receipt.number}}</p>
                <div class="currency">
                    <p>{{receipt.amount - (receipt.refund || 0) | currency}}</p>
                    <p class="text-truncate subtitle">{{receipt.category | lowercase}}</p>
                </div>
            </li>
        }
    </ul>
</div>

<receipt [id]="receiptId" [key]="key" (closed)="receiptClosed($event)"></receipt>